import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  { ProductivityReportLayer }  from '../components/reports/ProductivityReport'

export const ProductivityReportPage = () => {
  return (
<MasterLayout>
  <ProductivityReportLayer/>
</MasterLayout> )
}
